<template lang="pug">
    .hz-form-item(:class="[{ 'is-required': requiredCls }, validateStyle]")
        label.hz-form-item__label(:style="{'width': labelWidth}", :title="label") {{label}}
        .hz-form-item__content(:style="{'margin-left': labelWidth}")
            slot
            .hz-form-item__error(v-if="errorMsg") {{errorMsg}}        
</template>

<script>
    import Emitter from './util/emitter'
    export default {
        name: 'hz-form-item',
        mixins: [Emitter],
        props: {
            label: { type: String, default: null },
            must: { type: Boolean, default: false },
            required: { type: Boolean, default: false },
            rules: { type: Array },
            prop: { type: String},
            noError: { type: Boolean, default: false }
        },
        inject: ['labelWidth', 'rulesAll', 'modelSource'],
        data(){
            return {
                errorMsg: '',
                status: '',
                model: this.modelSource,
                rule: this.rules || this.rulesAll[this.prop]
            }
        },
        created(){
            this.$on("validate", _ => {
                if(this.prop && !this.status){
                    this.validate(this.value)
                }
                this.broadcast("hz-form-item", 'validate');
            })
            this.$on("reset", _ => {
                this.status = '';
                this.errorMsg = '';
                this.broadcast("hz-form-item", 'reset');
            })
            this.$on("initModel", res => {
                this.model = res
                this.broadcast("hz-form-item", 'initModel', res);
            })
            this.$on("initRules", res => {
                if(!this.rules){
                    this.rule = res[this.prop]
                }
                this.broadcast("hz-form-item", 'initRules', res);
            })
        },
        computed: {
            value(){
                return this.model[this.prop]
            },
            requiredCls(){
                if(this.required) return true;
                if(!this.rule) return false
                const obj = this.rule.find(item => item.required == true);
                return !!obj || this.must;
            },
            validateStyle(){
                if(this.noError || !this.status){
                    return ''
                }else{
                    return `is-${this.status}`
                }
            }
        },
        watch: {
            value(val, oldValue){
                this.validate(val)
            }
        },
        methods: {
            validate(val){
                if(!this.rule) return ;
                /**
                 *  required, message, type, validator, max, min
                 */
                const result = {
                    status: null,
                    msg: ''
                };
                const type = Object.prototype.toString.call(val).slice(8, -1);
                if(type == 'String'){
                    val = val.trim();
                }

                for(let i = 0; i < this.rule.length; i++){
                    let item = this.rule[i];
                    
                    //非空校验
                    if(item.required){
                        if( (type == 'Array' && val.length == 0) || val === null || val === undefined || val === ''){
                            result.status = false;
                            result.msg = item.message;
                            break;
                        }else{
                            result.status = true;
                        }
                    }
                    
                    //长度大小校验
                    if(item.min || item.max){
                        if(val){
                            if(( item.min && val.length < item.min) || (item.max  && val.length > item.max)){
                                result.status = false;
                                result.msg = item.message;
                                break;
                            }else{
                                result.status = true;
                            }
                        }else{
                            result.status = null;
                            continue;
                        }
                        
                    }

                    //类型校验
                    if(item.type){
                         if(!val){
                            result.status = null;
                            continue;
                        }
                        let regx;
                        switch(item.type){
                            case 'number':
                                regx = /^(\-|\+)?\d+(\.\d+)?$/
                                break;
                            case 'email':
                                regx = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/
                                break;
                            case 'url':
                                regx = '(https?|ftp|file)://[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]'
                                break;
                            case 'phone':
                                regx = /((\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$)/
                                break;
                            case 'password':
                                regx = /(?=.*[a-z])(?=.*\d)[a-z\d#@!~%^&*]{6,20}/i
                                break;
                        }
                        if(!val.toString().match(regx)){
                            result.status = false;
                            result.msg = item.message;
                            break;
                        }else{
                            result.status = true;
                        }
                    }

                    if(item.validator){
                        item.validator(val, res => {
                            if(res instanceof Error){
                                result.status = false;
                                result.msg = res.message;
                                
                            }else{
                                result.status = true;
                            }
                        })
                        if(result.status === false){
                            break;
                        }
                    }
                }
                this.errorMsg = result.msg;
                if(result.status === null){
                    this.status = ''
                    result.status = true;
                }else{
                    this.status = result.status ? 'success' : 'error'
                }
                this.dispatch('hz-form', 'validate', {[this.prop]: result.status})
            }
        }
    }
</script>
<style lang="stylus">
    .hz-form-item
        margin-bottom: 14px
        .hz-form-item
            display: inline-block
            .hz-form-item__content
                margin-left: 0 !important
        &.is-required .hz-form-item__label:before
            content: "*"
            color: #f56c6c
            margin-right: 4px
        &.is-required
            .is-required .hz-form-item__label:before
                display: none
        &:before
            display: table
            content: ""
        &.is-error
            input[type="date"],input[type="text"],input[type="url"],input[type="number"],input[type="password"], .hzIptResult, textarea
                border-color: #f56c6c
        &.is-success
            input[type="date"],input[type="text"],input[type="url"],input[type="number"],input[type="password"], .hzIptResult, textarea
                border-color: #67c23a


    .hz-form-inline
        .hz-form-item
            display: inline-block
            margin-right: 10px
            vertical-align: top
            margin-bottom: 0
        .hz-form-item__label
            float: none
            display: inline-block
        .hz-form-item__content
            display: inline-block
            vertical-align: top   
    .hz-form-item__label
        text-align: right
        vertical-align: middle
        float: left
        font-size: 14px
        color: #606266
        line-height: 40px
        padding: 0 12px 0 0
        box-sizing: border-box
        overflow: hidden
        text-overflow: ellipsis
        white-space: nowrap
    .hz-form-item__content
        line-height: 40px
        position: relative
        font-size: 14px
        .hz-form-item__error
            color: #f56c6c
            font-size: 12px
            line-height: 1
            position: absolute
            top: 100%
            left: 0
</style>


            


// WEBPACK FOOTER //
// src/formItem.vue